import { SORT_COLUMNS } from "@/pages/requests/components/users/components/constants";
import { SortDirectionsProps } from "@/pages/requests/components/users/components/types";
import { ChangeEvent } from "react";
import { Person } from "@/services";

export interface UsersTableFormProps {
  onSetIsValidStep: (isValid: boolean) => void;
}

// export interface User {
//   Id?: string | boolean;
//   WorkerId: string;
//   NameEn?: string;
//   NameAr?: string;
//   LastNameEn?: string;
//   LastNameAr?: string;
//   JobTitleEn?: string;
//   JobTitleAr?: string;
//   ResidencyAr?: string;
//   PassportNumber?: string;
//   isDisabled?: boolean;
//   Nationality?: string;
//   Medical?: string;
//   EmiratesId?: string;
//   Hse?: string;
//   ToxicGas?: string;
//   OnboardingStatus?: string;
//   OnboardingComments?: string;
//   Company?: string; // TODO Does this field exist?
//   CompanyAr?: string;
//   CompanyEn?: string;
//   Value?: string | boolean;
// }

export interface TableHeaderProps {
  data: Person[] | null;
  searchValue: string;
  sortDirections: SortDirectionsProps;
  appliedFilters: Record<string, string>;
  selectedOptions: Person[];
  isSelectedAll: boolean;
  isPartialSelected: boolean;
  onToggleAll: (e: ChangeEvent<HTMLInputElement>) => void;
  onSortBy: (column: SORT_COLUMNS) => void;
  onSearch: (value: string) => void;
  onFilterChange: (item: Person) => void;
  onApplyFilters: (
    status: boolean,
    id: SORT_COLUMNS,
    selectedOptions: Person[],
  ) => void;
  isInbox?: boolean;
}

export interface TableRowProps {
  item: Person;
  isInbox?: boolean;
  isCheckedUser?: Person;
  onToggleSelectUser: (item: Person, isChecked: boolean) => void;
  onToggleUserModal: (item: Person) => void;
}

export interface PaginationProps {
  activeChunk: number;
  data: Person[];
  dataChunks: Person[][];
  onChunkChange: (direction: string) => void;
}

export enum PaginationDirection {
  NEXT = "next",
  PREV = "prev",
}

export interface UserModalProps {
  user: Person | null;
  isOpen: boolean;
  onClose: (user: Person | null) => void;
}

export interface UserOpsProps {
  data: Person[] | null;
  onSelectUser?: (user: Person[], id: UsersField.Users) => void;
}

export enum UsersField {
  Users = "Personnels",
  UsersAccurancy = "UsersAccurancy",
}
